import type { AxiosTransformer } from 'axios';
import { camelize } from './common';

export enum ContentTypes {
  jsonDefault = 'application/json',
  json = 'application/json; charset=utf-8',
  vndJson = 'application/vnd.s.v1+json; charset=utf-8',
  vndJsonLegacy = 'application/vnd.softswiss.v1+json; charset=utf-8',
  vndJsonV2 = 'application/vnd.s.v2+json; charset=utf-8',
  vndJsonV2Legacy = 'application/vnd.softswiss.v2+json; charset=utf-8',
}

export function getResponseDefault(): AxiosTransformer {
  return (data, headers) => {
    if (
      headers != null &&
      headers['content-type'] != null &&
      (headers['content-type'] === ContentTypes.vndJson ||
        headers['content-type'] === ContentTypes.vndJsonLegacy ||
        headers['content-type'] === ContentTypes.vndJsonV2 ||
        headers['content-type'] === ContentTypes.json)
    ) {
      let jsonResp;

      try {
        jsonResp = JSON.parse(data);
      } catch (e) {
        return {};
      }

      return jsonResp;
    }

    return data;
  };
}

export function getResponseCamelization(
  blacklists?: string[][]
): AxiosTransformer {
  return (data, headers) => {
    if (
      headers != null &&
      headers['content-type'] != null &&
      (headers['content-type'] === ContentTypes.vndJson ||
        headers['content-type'] === ContentTypes.vndJsonLegacy ||
        headers['content-type'] === ContentTypes.vndJsonV2 ||
        headers['content-type'] === ContentTypes.json)
    ) {
      let jsonResp;

      try {
        jsonResp = JSON.parse(data);
      } catch (e) {
        return {};
      }

      return camelize(jsonResp, blacklists);
    }

    return data;
  };
}
